// The one Offer every Product node in the site's JSON-LD carries.
//
// Moved verbatim from /bike-insurance's Product node, which had the only Offer
// on a Product. A Product with no offers, review or aggregateRating is not
// eligible for Google's product rich results, and since the stale rating was
// removed (PS-56) that described every other Product node. Same price, same
// wording, same quote date - do not edit here without editing the pages that
// state the same "from £2.47" figure in copy.
import { getCanonicalUrl } from '@/helpers/seo'

export function productOffer() {
  return {
    '@type': 'Offer',
    priceCurrency: 'GBP',
    price: '2.47',
    priceSpecification: {
      '@type': 'UnitPriceSpecification',
      price: '2.47',
      priceCurrency: 'GBP',
      unitCode: 'MON',
      description:
        'From £2.47 per month, inclusive of Insurance Premium Tax, for a bike valued at £400. Rider aged 30, postcode SW1A 1AA, quoted 17 August 2026. Your price depends on bike value, age, postcode and cover selected.',
    },
    availability: 'https://schema.org/InStock',
    areaServed: ['GB', 'IM'],
    url: getCanonicalUrl('/quote'),
    // Sitewide Organization node. Nothing publishes this @id yet —
    // see the note in the build summary; it is a separate ticket.
    seller: { '@id': `${getCanonicalUrl('/')}#organization` },
  }
}
